import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import { cn } from '@/app/lib';
import type { AccordionItem } from '@workspace/interfaces';

interface AccordionItemRowProps {
  item: AccordionItem;
  isExpanded: boolean;
  onToggle: () => void;
}

export function AccordionItemRow({ item, isExpanded, onToggle }: AccordionItemRowProps) {
  return (
    <div className="transition-shadow duration-200">
      <div
        onClick={onToggle}
        className={cn(
          'flex items-center justify-between w-full pt-4 pb-1 focus:outline-none transition-colors duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] border-b-sm pr-2.5 pl-3xs',
          isExpanded ? 'border-primary border-b ' : 'border-secondary-100 border-b',
        )}
        aria-expanded={isExpanded}
        aria-controls={`accordion-content-${item.id}`}
      >
        <Typography
          variant="h4"
          className={cn(
            'font-bold transform-gpu transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] cursor-pointer motion-reduce:transition-none',
            isExpanded
              ? '!text-primary !text-2xl md:!text-2xl scale-105'
              : '!text-gray-900 !text-lg scale-100 font-bold',
          )}
        >
          {item.title}
        </Typography>

        <div
          className={cn(
            'transform-gpu transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
            isExpanded ? 'rotate-180 scale-110' : 'rotate-0 scale-100',
          )}
        >
          <Icon
            name="ChevronDown"
            size={20}
            className={cn(
              'transition-colors duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] cursor-pointer motion-reduce:transition-none',
              isExpanded ? 'text-primary' : 'text-gray-900',
            )}
          />
        </div>
      </div>
    </div>
  );
}
